module.exports = __webpack_public_path__ + "img/CM-NL-24-Volkswagen-Established.123fe96c.jpg";